import ApiServer from "../ApiServer.js";
import * as modal from "../util/modal.ts";
import * as FwDatas from "../FwDatas.ts";
import * as i18n from "../i18n.ts";
import * as libLocation from "../lib/location.ts";
import * as Html from "../util/Html.ts";

export {init}
Html.registerWidget('widget/view-invitation-opener',{init:init})

var currentModal;
ApiServer["custom.famupdateinvitationresend"] = ApiServer.group([
  ApiServer.famupdateinvitation,
  ApiServer.famresendinvite
],function(){
  modal.closeModal(currentModal);
  libLocation.refresh();
});

Html.register({
  'modalinvitation':function(){
    var metaId = this.attr("data-fw-meta-id");
    FwDatas.getFamily().invitations.forEach(function(invitation){
      if(invitation.metaId===metaId){
        if(invitation.editable){
          import("../modal/invitation_edit.mustache").then(TPL=>{
            currentModal = modal.openModal(TPL,invitation);
          })
        }else{
          import("../modal/invitation_view.mustache").then(TPL=>{
            currentModal = modal.openModal(TPL,invitation);
          })
        }
      }
    });
  },
  'invitationdelete':function(){
    var metaId = this.metaId();
    modal.confirmDelete('editAccount.confirmBeforeDeletingFamilyMember',function(){
      ApiServer.famcancelinvite(metaId,function(){
        modal.closeModal(currentModal);
        modal.alert("editAccount.familyMemberDeleted",function(){
          libLocation.refresh();
        });
        
      });
    });
  }
});

function init(obj){
  obj.attr('data-fw-onclick',"modalinvitation");
}